import React, { createContext, useContext, useEffect, useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faHouseUser, faBuildingColumns, faTag, faRightLeft, faChartPie, faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons';
import { SCOPE_TEMA } from './contiTheme';
import { getContoMovimenti } from '../../services/contiService';

const ContiContext = createContext({ scope: 'azienda', tema: SCOPE_TEMA.azienda });
export const useConti = () => useContext(ContiContext);

const SCOPE_ICONE = { azienda: faBuilding, personale: faHouseUser };

const leggiScope = () => {
  try {
    const s = localStorage.getItem('conti_scope');
    return s === 'personale' ? 'personale' : 'azienda';
  } catch (e) {
    return 'azienda';
  }
};

const ContiLayout = () => {
  const [scope, setScope] = useState(leggiScope);
  const [conteggi, setConteggi] = useState({ da_classificare: 0, da_registrare: 0 });
  const tema = SCOPE_TEMA[scope];

  const cambiaScope = (s) => {
    setScope(s);
    try { localStorage.setItem('conti_scope', s); } catch (e) { /* senza memoria locale: nessun problema */ }
  };

  const aggiornaConteggi = () => getContoMovimenti().then(setConteggi).catch(() => {});
  useEffect(() => { aggiornaConteggi(); }, []);

  const voci = [
    { to: '/conti/movimenti', label: 'Movimenti', icona: faRightLeft, badge: conteggi.da_classificare },
    { to: '/conti/rapporti', label: 'Rapporti bancari', icona: faBuildingColumns },
    { to: '/conti/piano', label: 'Piano dei conti', icona: faTag },
    { to: '/conti/finanziamenti', label: 'Finanziamenti', icona: faHandHoldingDollar },
    { to: '/conti/bilancio', label: 'Bilancio', icona: faChartPie },
  ];

  return (
    <ContiContext.Provider value={{ scope, tema, aggiornaConteggi, conteggi }}>
      <Container fluid className="py-3 px-md-4">
        <div style={{ background: tema.gradiente, borderRadius: 18, padding: '20px 24px', color: '#fff', boxShadow: '0 8px 24px rgba(0,0,0,.12)' }}>
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div>
              <div style={{ opacity: 0.85, fontSize: 13, letterSpacing: 1, textTransform: 'uppercase' }}>Contabilità</div>
              <h3 className="mb-0" style={{ fontWeight: 700 }}>{tema.nome}</h3>
            </div>
            <div className="d-flex gap-2 p-1" style={{ background: 'rgba(255,255,255,.18)', borderRadius: 999 }}>
              {Object.keys(SCOPE_TEMA).map((s) => (
                <button
                  key={s}
                  type="button"
                  onClick={() => cambiaScope(s)}
                  style={{
                    border: 0, borderRadius: 999, padding: '8px 18px', fontWeight: 600, cursor: 'pointer',
                    background: scope === s ? '#fff' : 'transparent', color: scope === s ? SCOPE_TEMA[s].scuro : '#fff',
                    transition: 'all .15s',
                  }}
                >
                  <FontAwesomeIcon icon={SCOPE_ICONE[s]} className="me-2" />{SCOPE_TEMA[s].nome}
                </button>
              ))}
            </div>
          </div>
          <div className="d-flex flex-wrap gap-2 mt-3">
            {voci.map((v) => (
              <NavLink
                key={v.to}
                to={v.to}
                style={({ isActive }) => ({
                  textDecoration: 'none', padding: '8px 16px', borderRadius: 10, fontWeight: 600, fontSize: 14,
                  background: isActive ? '#fff' : 'rgba(255,255,255,.14)', color: isActive ? tema.scuro : '#fff',
                })}
              >
                <FontAwesomeIcon icon={v.icona} className="me-2" />{v.label}
                {v.badge > 0 && (
                  <span className="ms-2 badge rounded-pill" style={{ background: '#fa5252', color: '#fff' }}>{v.badge}</span>
                )}
              </NavLink>
            ))}
          </div>
        </div>
        <div className="mt-3"><Outlet /></div>
      </Container>
    </ContiContext.Provider>
  );
};

export default ContiLayout;
